'use strict';

import React from 'react';

require('styles//GestaoPage.css');

class GestaoPageComponent extends React.Component {
  render() {
    return (
      <div className="gestaopage-component">
        <div className="header">
          <h2 className="page-title">Gestão</h2>
          <div className="page-description">
            <p>
              Com uma equipa de profissionais com mais de 20 anos de experiência, a Labor Team presta serviços em outsourcing que contemplam as áreas de gestão administrativa de pessoal.
            </p>
            <p>
              Com os nossos serviços poderá usufruir da redução de custos em pessoal administrativo, software, consumíveis e hardware e concentrar os seue recursos nas atividades que o distinguem.
            </p>
          </div>
        </div>

        <section>
          <h1 className="section-title">Serviços</h1>

          <div className="solution">
            <img className="solution-logo" src="/static/images/gestao/salarios.svg" alt="Processamento de Salários"/>
            <div className="solution-info">
              <h3 className="title">Processamento de Salários</h3>
              <div>
                <p>
                  Processamos vencimentos para empresas e gabinetes de contabilidade em regime de outsourcing. Contamos com uma equipa com mais de 20 anos de experiência no processamento salarial.
                </p>
                <p>
                  Processamos o salário dos seus trabalhadores a partir de 20€/mês.
                </p>
              </div>
            </div>
          </div>

          <div className="solution">
            <img className="solution-logo" src="/static/images/gestao/gestao.svg" alt="Gestão Administrativa de Pessoal"/>
            <div className="solution-info">
              <h3 className="title">Gestão Administrativa de Pessoal</h3>
              <div>
                <p>Para além do Processamento de Salários efetuamos a Gestão Administrativa de Pessoal através de outros serviços:</p>
                <ul>
                  <li>lnscrição obrigatória de trabalhadores na Segurança Social;</li>
                  <li>lnscrição obrigatória no Fundo de Conpensação;</li>
                  <li>Elaboração e envio de Recibos de vencimento;</li>
                  <li>Elaboração e envio da Mapas de remunerações para Segurança Social;</li>
                  <li>Elaboração e entrega da DMR (declaração mensal de remunerações);</li>
                  <li>Elaboração e envio de Mapas de Remunerações para Seguradora;</li>
                  <li>Elaboração de Ficheiro para transferências bancarias;</li>
                  <li>Gestão da base de Dados de Registo de  trabalhadores;</li>
                  <li>Emissão da declaração anual de rendimentos por trabalhador;</li>
                  <li>Elaboração de certificados de Trabalho;</li>
                  <li>Comunicação da admissão de Trabalhadores da Empresa;</li>
                  <li>Comunicação da demissão de Trabalhadores da Empresa;</li>
                  <li>Elaboração dos Mapas de Férias;</li>
                  <li>Avisos sobre a cessação/renovação de contratos de trabalho a termo;</li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

GestaoPageComponent.displayName = 'GestaoPageComponent';

// Uncomment properties you need
// GestaoPageComponent.propTypes = {};
// GestaoPageComponent.defaultProps = {};

export default GestaoPageComponent;



// WEBPACK FOOTER //
// ./src/components/GestaoPageComponent.js